import { NgModule } from "@angular/core";
import { ToggleDirective } from "./toggle.component";

@NgModule({
    declarations: [ToggleDirective],
    exports: [ToggleDirective]
})
export class ToggleModule {}
